import Header from "components/Headers/Header";
import React from "react";
import { useSelector } from "react-redux";
import { Button, Container, Row, Col, Card, CardBody, Alert } from "reactstrap";
import sidePic from "../../assets/img/custom/SideIconFHP.png";
import QRCode from "react-qr-code";

const YourCards = () => {
  const { user } = useSelector((state) => state.auth);
  const isSmallScreen = window.innerWidth < 768;

  const handlePrint = (divPrint) => {
    var printContents = document.getElementById(divPrint).innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  return (
    <>
      <Header />

      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Header */}
          <div className="bg-gradient-primary p-4 text-white d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
                ATHLETE IDENTITY
              </span>
              <h2 className="text-white mb-0 mt-1 font-weight-700">
                My Business Card
              </h2>
            </div>
            <Button 
              color="neutral" 
              className="text-primary font-weight-700 rounded-pill px-4 mt-2 mt-sm-0" 
              onClick={() => handlePrint("printMe")}
            >
              <i className="fas fa-print mr-2"></i> Print/Download Card
            </Button>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <Row className="align-items-stretch">
              {/* Instructions Side */}
              <Col lg="5" className="mb-4 mb-lg-0">
                <div className="bg-white p-4 rounded-4 shadow-sm h-100 d-flex flex-column justify-content-between">
                  <div>
                    <h3 className="h4 text-dark font-weight-700 mb-4">
                      <i className="fas fa-info-circle text-primary mr-2"></i> Printing Instructions
                    </h3>
                    
                    <div className="mb-4">
                      <h5 className="font-weight-700 text-dark mb-1">A. Print on Paper</h5>
                      <p className="text-muted" style={{ fontSize: "0.875rem" }}>
                        Click the print button to generate a physical copy of your FHP business card. Cardstock or heavier paper is recommended.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-weight-700 text-dark mb-1">B. Hand Out to Fans</h5>
                      <p className="text-muted" style={{ fontSize: "0.875rem" }}>
                        Distribute these cards to your supporters so they can easily access your registration link and buy your badges!
                      </p>
                    </div>
                  </div>

                  <Alert color="info" className="border-0 rounded-3 mb-0">
                    <small className="font-weight-600">
                      <i className="fas fa-qrcode mr-1"></i> Card contains active QR codes pointing to FHP portals.
                    </small>
                  </Alert>
                </div>
              </Col>

              {/* Card Preview Side */}
              <Col lg="7">
                <div className="bg-white p-4 rounded-4 shadow-sm text-center h-100 d-flex flex-column align-items-center justify-content-center">
                  <span className="text-uppercase tracking-wider text-muted font-weight-700 mb-4" style={{ fontSize: "11px" }}>
                    Live Preview
                  </span>

                  <div id="printMe" className="w-100 d-flex justify-content-center">
                    {/* The Styled Printable Business Card */}
                    <div 
                      className="PrintCard shadow border" 
                      style={{ 
                        width: "360px", 
                        minHeight: "220px", 
                        borderRadius: "16px", 
                        backgroundColor: "#ffffff", 
                        border: "1.5px solid #e2e8f0", 
                        padding: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between"
                      }}
                    >
                      {/* Name & Reg Line */}
                      <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                        <div className="text-left">
                          <small className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: "9px", letterSpacing: "1px" }}>
                            ATHLETE
                          </small>
                          <span className="text-dark font-weight-700 h4 mb-0 d-block">
                            {user?.first_name} {user?.last_name}
                          </span>
                        </div>
                        <div className="text-right">
                          <small className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: "9px", letterSpacing: "1px" }}>
                            REGISTRATION #
                          </small>
                          <span className="text-primary font-weight-700 h4 mb-0 d-block">
                            {user?.athleteID}
                          </span>
                        </div>
                      </div>

                      {/* QR codes & branding */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* FHP QR */}
                        <div className="d-flex align-items-center">
                          <QRCode
                            title="fhp"
                            value={`https://fans-help-players-athlete.web.app`}
                            size={55}
                          />
                          <div className="text-left ml-2" style={{ lineHeight: "1.2" }}>
                            <span className="text-dark font-weight-800 d-block" style={{ fontSize: "10px" }}>FANS</span>
                            <span className="text-primary font-weight-800 d-block" style={{ fontSize: "10px" }}>HELP</span>
                            <span className="text-danger font-weight-800 d-block" style={{ fontSize: "10px" }}>PLAYERS</span>
                          </div>
                        </div>

                        {/* A4B QR */}
                        <div className="d-flex align-items-center">
                          <QRCode
                            title="A4B"
                            value={`https://athlete-for-brand.web.app`}
                            size={55}
                          />
                          <div className="text-left ml-2" style={{ lineHeight: "1.2" }}>
                            <span className="text-dark font-weight-800 d-block" style={{ fontSize: "10px" }}>AMBASSADOR</span>
                            <span className="text-success font-weight-800 d-block" style={{ fontSize: "10px" }}>4BRAND</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default YourCards;
